module.exports = __webpack_public_path__ + "img/currency6.bd850b54.png";